import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SuperAdminService } from '@core/services/super-admin.service';
import { CustomValidator } from '@shared/services/custom-validatior.abstract';
import { CommonFunctions } from '@shared/common-functions';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-access-code-modal',
  templateUrl: './access-code-modal.component.html',
  styleUrls: ['./access-code-modal.component.scss']
})

export class AccessCodeModalComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  accessCodeForm: FormGroup;
  id: string;
  dailyAccessCode: string;
  monthlyAccessCode: string;

  constructor(private readonly service: SuperAdminService,
    private readonly fb: FormBuilder,
    private readonly config: DynamicDialogConfig,
    private readonly ref: DynamicDialogRef,
  ) {
    this.accessCodeForm = this.fb.group({
      oneTimeAccessCode: ['', [Validators.required, Validators.minLength(2)]],
      monthlyAccessCode: ['', [Validators.required, Validators.minLength(2)]],
    })
  }

  ngOnInit() {
    this.id = this.config?.data?.parkingLotId;
    this.dailyAccessCode = this.config?.data?.dailyAccessCode;
    this.monthlyAccessCode = this.config?.data?.monthlyAccessCode;
  }

  save() {
    if (!this.accessCodeForm.valid) {
      CustomValidator.markFormGroupTouched(this.accessCodeForm);
      return;
    }
  
    const req = {
      parkingLotId: this.id,
      OneTimeAccessCode: this.accessCodeForm.value.oneTimeAccessCode,
      RecurringAccessCode: this.accessCodeForm.value.monthlyAccessCode,
    };

this.service.UpdateParkingLotAccessCodes(req)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response) => {
        if (response) {
          this.ref.close(response);
        }
      }
    });
  }
  
  close() {
    this.ref.close();
  }

  preventSpaces(event: KeyboardEvent) {
    CommonFunctions.preventSpaces(event);
  }
}